<template>
  <section>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-header">
        <h1>doładowania konta</h1>
        <a href="#" @click.prevent="showHelp = !showHelp">potrzebujesz pomocy</a>
      </div>

      <hr>

      <div class="topup-form-help" v-if="showHelp">
        <div>
          <p>
            Doładowanie konta na naszej stronie jest bezpieczne i proste. Możesz doładować jeden numer albo kilka w ramach jednej transakcji.
          </p>
          <ul>
            <li>wpisujesz numer/numery, które chcesz doładować i wybierasz kwoty doładowania</li>
            <li>wybierasz, jak chcesz zapłacić</li>
            <li>potwierdzasz transakcję (zgodnie z wymogami Twojego banku)</li>
            <li>cieszysz się i korzystasz z nowych środków na koncie</li>
          </ul>
          <p>Po realizacji transakcji dostaniesz potwierdzenie mailem i SMSem. Tak dla pewności.</p>
        </div>
        <hr>
      </div>

      <p>Na stronie doładowań njumobile komórkę o każdej porze dnia i nocy doładować możesz. Miło tak. Wystarczy, że konto bankowe albo kartę płatniczą masz. Możesz doładować swoje konto lub konto innej osoby, która też jest w nju. Albo kilku osób, bo też można. Szybkie to jest i proste. Sam zobacz.</p>

      <div class="topup-error" v-if="topupError">
        <h3>Podczas przetwarzania doładowania wystapił błąd!</h3>
        <p>Spróbuj ponownie lub skonsultuj się z pomocą techniczną.</p>
      </div>
      <div class="topup-error" v-if="formError">
        <h3>Uzupełnij wszystkie wymagane pola formularza!</h3>
      </div>

      <div class="topup-form-frame">

        <h2>wprowadź numer telefonu do doładowania</h2>
        <div class="topup-form-fields">
          <div>
            <section class="topup-form-field-zone" v-for="(topup, topupIndex) in form.topup" :key="topupIndex">
              <div class="topup-form-field">
                <div class="topup-form-field-container" :class="{error: hasTopupError(topupIndex)}">
                  <label :for="'form-phone-' + topupIndex">numer telefonu</label>
                  <input type="text"
                         :id="'form-phone-' + topupIndex"
                         class="topup-phone"
                         ref="topupPhoneInput"
                         v-model="topup.phone"
                         :disabled="isCheckPhoneInProgress(topupIndex)"
                         autocomplete="off"
                         @keyup="checkPhone(topupIndex)"
                         @paste="checkPhoneOnPaste($event, topupIndex)"
                         v-mask="'###-###-###'"
                         placeholder="___-___-___">
                  <a href="#"
                     class="remove-topup"
                     @click.prevent="removeTopup(topupIndex)"
                     v-if="canRemoveTopup() && !isCheckPhoneInProgress(topupIndex)">
                    usuń
                  </a>
                  <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isCheckPhoneInProgress(topupIndex)"/>
                </div>
                <div class="topup-form-error-container phone-error" v-if="hasTopupError(topupIndex)">
                  <ul>
                    <li v-if="isPhoneEmpty(topupIndex)">Numer telefonu jest wymagany</li>
                    <li v-if="!isPhoneEmpty(topupIndex) && !isPhoneValid(topupIndex)">Numer telefonu jest
                      nieprawidłowy
                    </li>
                    <li v-if="isPhoneValid(topupIndex) && isCheckPhoneError(topupIndex)">Numer telefonu nie może być
                      doładowany
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section class="topup-form-field-zone">
              <div class="topup-form-field">
                <div class="topup-form-field-container" :class="{error: hasEmailError()}">
                  <label for="form-email">adres e-mail</label>
                  <input type="text"
                         id="form-email"
                         v-model="form.email"
                         @blur="checkEmail"
                         placeholder="podaj adres e-mail">
                </div>
                <div class="topup-form-error-container email-error" v-if="hasEmailError()">
                  <ul>
                    <li v-if="isEmailEmpty()">Adres e-mail jest wymagany</li>
                    <li v-if="!isEmailEmpty() && !isEmailValid()">Adres e-mail jest nieprawidłowy</li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="topup-form-additional-button">
          <button type="button"
                  id="add-topup"
                  class="btn"
                  v-if="canAddTopup()"
                  @click="addTopup">
            <span>
              dodaj kolejny numer
            </span>
          </button>
        </div>
        <hr>

        <h2>kwota doładowania</h2>
        <section class="topup-amounts-container" v-for="(topup, topupIndex) in form.topup" :key="topupIndex">
          <div v-if="topupIndex === 0 || !isPhoneEmpty(topupIndex)">
            <h3 v-if="form.topup.length > 1 && !isPhoneEmpty(topupIndex)">dla numeru {{topup.phone}}</h3>
            <div class="topup-amounts">
              <label :for="'amount-' + topupIndex + '-' + amountIndex" v-for="(amount, amountIndex) in TOPUP_AMOUNTS" :key="amountIndex">
                <input type="radio"
                       v-model="form.topup[topupIndex].amount"
                       :value="amount"
                       :id="'amount-' + topupIndex + '-' + amountIndex">
                <span class="topup-amount-value">{{amount}} zł</span>
              </label>
            </div>
          </div>
        </section>

        <hr>

        <div class="topup-agreements">
          <div class="with-checkbox">
            <input type="checkbox" id="checkAll" v-model="checkAll"/>
            <label class="check-label" for="checkAll">
              <span class="check-label-box"></span>
              <span class="check-label-text"><strong>Zaznacz wszystkie zgody</strong></span>
            </label>
          </div>
          <div class="with-checkbox">
            <input type="checkbox" id="agreement" v-model="form.agreement"/>
            <label class="check-label" for="agreement">
              <span class="check-label-box"></span>
              <span class="check-label-text"><span class="red">*</span> Zapoznałem się i akceptuję <a href="/files/njumobile/Regulamin-doladowan-Njumobile.pdf" target="_blank" rel="noreferrer">Regulamin doładowań telefonów komórkowych</a> oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Politykę prywatności</a></span>
            </label>
            <div class="topup-form-error-container" v-if="hasAgreementError()">
              <ul>
                <li v-if="!isAgreementSet()">Zgoda jest wymagana</li>
              </ul>
            </div>
          </div>
          <div class="with-checkbox">
            <input type="checkbox" id="payment" v-model="form.payment"/>
            <label class="check-label" for="payment">
              <span class="check-label-box"></span>
              <span class="check-label-text"><span class="red">*</span> Chcę, aby usługa została zrealizowana niezwłocznie i przyjmuję do wiadomości, że w przypadku pełnego wykonania usługi, z chwilą jej wykonania, utracę prawo do odstąpienia od umowy.</span>
            </label>
            <div class="topup-form-error-container" v-if="hasPaymentError()">
              <ul>
                <li v-if="!isPaymentSet()">Zgoda jest wymagana</li>
              </ul>
            </div>
          </div>
          <p><span class="red">*</span> pole wymagane</p>
        </div>
        <div class="topup-privacy">
          <p>
            Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot. Podanie
            danych osobowych jest dobrowolne, ale niezbędne do realizacji usługi doładowania. Podstawa prawna, cel,
            okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne
            informacje dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a
            href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf"
            target="_blank" rel="noreferrer">Polityce prywatności Autopay S.A.</a>
          </p>
          <p>
            Autopay korzysta z plików cookie. Pozostając na tej stronie, wyrażasz zgodę na korzystanie z plików
            cookie zgodnie z <a
            href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf"
            target="_blank" rel="noreferrer">Polityką prywatności Autopay S.A.</a> Możesz samodzielnie zarządzać
            cookies zmieniając
            odpowiednio ustawienia swojej przeglądarki lub oprogramowania urządzenia.
          </p>
        </div>
      </div>

      <hr>

      <div class="topup-form-buttons">
        <button id="invoice" class="btn btn-frame" @click="toggleInvoiceInfoVisible" type="button">faktura</button>
        <button id="submit" class="btn" type="submit" :disabled="isLoading || isMaintenanceGlobal">płacę</button>
      </div>
    </form>
    <topup-invoice v-if="isInvoiceLayerVisible" />
  </section>
</template>

<script>
import {
  TOPUP_COOKIE_BACK_URL_NAME, TOPUP_PHONE_WITHOUT_PREFIX_LENGTH,
  TOPUP_RESPONSE_SUCCESS
} from '@/common/const/topup.const'
import { TOPUP_TEMPLATE } from '../../const/topup.const'
import { apiClass } from '@/common/class/api.class'
import { ToolsClass } from '@/common/class/tools.class'
import { CookieClass } from '@/common/class/cookie.class'
import { ENDPOINTS } from '@/common/const/endpoints.const'
import { mapActions, mapMutations, mapState } from 'vuex'
import TopupInvoice from './Invoice'
import { IS_MAINTENANCE_GLOBAL } from '@/common/const/maintenance.const'

export default {
  name: 'TopupForm',
  components: { TopupInvoice },
  data () {
    return {
      form: {
        topup: [],
        email: null,
        isEmailValid: null,
        isEmailEmpty: true,
        agreement: false,
        payment: false
      },
      MAX_TOPUPS: this.$VUE_TOPUP_CONFIG.maxTopups,
      TOPUP_AMOUNTS: this.$VUE_TOPUP_CONFIG.topupAmounts,
      TOPUP_AMOUNT_MIN: this.$VUE_TOPUP_CONFIG.topupAmountMin,
      TOPUP_AMOUNT_MAX: this.$VUE_TOPUP_CONFIG.topupAmountMax,
      showAmountMinMessage: [],
      showAmountMaxMessage: [],
      topupError: false,
      formError: false,
      showHelp: false,
      isMaintenanceGlobal: IS_MAINTENANCE_GLOBAL
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.topup.loading,
      isInvoiceLayerVisible: state => state.invoice.visible
    }),
    checkAll: {
      get: function () {
        return this.form.agreement && this.form.payment
      },
      set: function (value) {
        if (value) {
          this.form.agreement = true
          this.form.payment = true
        } else {
          this.form.agreement = false
          this.form.payment = false
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_TOPUP_LOADING',
      'toggleInvoiceInfoVisible'
    ]),
    ...mapActions([
      'sendTopup'
    ]),
    canAddTopup () {
      return this.form.topup.length < this.$VUE_TOPUP_CONFIG.maxTopups
    },
    canRemoveTopup () {
      return this.form.topup.length > this.$VUE_TOPUP_CONFIG.minTopups
    },
    addTopup () {
      if (this.canAddTopup()) {
        this.form.topup.push(Object.assign({}, TOPUP_TEMPLATE, { amount: this.$VUE_TOPUP_CONFIG.topupAmountDefault }))
      }
    },
    removeTopup (index) {
      this.form.topup.splice(index, 1)
    },
    setCheckPhoneProgressFlag (topupIndex, value) {
      this.form.topup[topupIndex].checkPhoneInProgress = value
    },
    setCheckPhoneStatusFlag (topupIndex, value) {
      this.form.topup[topupIndex].isCheckPhoneStatusValid = value
    },
    isCheckPhoneInProgress (topupIndex) {
      return this.form.topup[topupIndex].checkPhoneInProgress
    },
    isCheckPhoneStatusSet (topupIndex) {
      return this.form.topup[topupIndex].isCheckPhoneStatusValid !== null
    },
    isCheckPhoneStatusValid (topupIndex) {
      return this.form.topup[topupIndex].isCheckPhoneStatusValid
    },
    isCheckPhoneError (topupIndex) {
      return this.isCheckPhoneStatusSet(topupIndex) && !this.isCheckPhoneStatusValid(topupIndex)
    },
    isPhoneValidSet (topupIndex) {
      return this.form.topup[topupIndex].isPhoneValid !== null
    },
    isPhoneEmpty (topupIndex) {
      return this.form.topup[topupIndex].isPhoneEmpty
    },
    isPhoneValid (topupIndex) {
      return this.form.topup[topupIndex].isPhoneValid
    },
    setPhoneValid (topupIndex, value) {
      this.form.topup[topupIndex].isPhoneValid = value
    },
    setPhoneEmpty (topupIndex, value) {
      this.form.topup[topupIndex].isPhoneEmpty = value
    },
    hasTopupError (topupIndex) {
      if (this.formError) {
        return this.isPhoneEmpty(topupIndex) ||
            (this.isPhoneValidSet(topupIndex) && !this.isPhoneValid(topupIndex)) || this.isCheckPhoneError(topupIndex)
      }
      return (this.isPhoneValidSet(topupIndex) && !this.isPhoneValid(topupIndex)) ||
          this.isCheckPhoneError(topupIndex)
    },
    isEmailValid () {
      return this.form.isEmailValid
    },
    isEmailEmpty () {
      return this.form.isEmailEmpty
    },
    hasEmailError () {
      if (this.formError) {
        return this.isEmailEmpty() || !this.isEmailValid()
      }
      return !this.isEmailEmpty() && !this.isEmailValid()
    },
    setEmailValid (value) {
      this.form.isEmailValid = value
    },
    setEmailEmpty (value) {
      this.form.isEmailEmpty = value
    },
    checkEmail () {
      let email = this.form.email
      this.setEmailValid(null)

      if (!email || !email.length) {
        this.setEmailEmpty(true)
        return
      }
      this.setEmailEmpty(false)

      if (!ToolsClass.isEmailValid(email)) {
        this.setEmailValid(false)
        return
      }

      this.setEmailValid(true)
    },
    hasAgreementError () {
      if (this.formError) {
        return !this.isAgreementSet()
      }
      return false
    },
    isAgreementSet () {
      return !!this.form.agreement
    },
    hasPaymentError () {
      if (this.formError) {
        return !this.isPaymentSet()
      }
      return false
    },
    isPaymentSet () {
      return !!this.form.payment
    },
    checkPhoneOnPaste (event, topupIndex) {
      let paste = (event.clipboardData || window.clipboardData).getData('text')
      if (paste && paste.length) {
        this.form.topup[topupIndex].phone = paste
        this.checkPhone(topupIndex)
      }
    },
    checkPhone (topupIndex) {
      let phone = this.form.topup[topupIndex].phone
      this.setPhoneValid(topupIndex, null)
      this.setCheckPhoneStatusFlag(topupIndex, null)
      this.setCheckPhoneProgressFlag(topupIndex, false)

      if (!phone || !phone.length) {
        this.setPhoneEmpty(topupIndex, true)
        return
      }

      this.setPhoneEmpty(topupIndex, false)

      if (ToolsClass.cleanPhoneNumber(phone).length < TOPUP_PHONE_WITHOUT_PREFIX_LENGTH) {
        this.setPhoneValid(topupIndex, false)
        return
      }

      if (!ToolsClass.isPhoneNumberValid(phone)) {
        this.setPhoneValid(topupIndex, false)
        return
      }

      this.setPhoneValid(topupIndex, true)
      this.setCheckPhoneProgressFlag(topupIndex, true)

      let data = {
        operator: this.$VUE_APP_OPERATOR,
        account: `48${ToolsClass.cleanPhoneNumber(phone)}`,
        amount: 5.00
      }
      apiClass.post(ENDPOINTS.phone.checkPhone, data)
        .then(response => {
          if (response.body.status === 1) {
            this.setCheckPhoneStatusFlag(topupIndex, true)
          } else {
            this.setCheckPhoneStatusFlag(topupIndex, false)
          }
        }, () => {
          this.setCheckPhoneStatusFlag(topupIndex, false)
        })
        .finally(() => {
          this.setCheckPhoneProgressFlag(topupIndex, false)
        })
    },
    enableOtherAmount (topupIndex) {
      if (this.isAmountOtherSet(topupIndex)) {
        return
      }

      this.form.topup[topupIndex].isAmountOtherSet = true
      this.form.topup[topupIndex].amount = null
      this.form.topup[topupIndex].amountOther = ''

      setTimeout(() => {
        let input = this.$refs.topupAmountOther[topupIndex].querySelector('input[type="text"]')
        if (input) {
          input.focus()
        }
      }, 100)
    },
    disableOtherAmount (topupIndex) {
      this.form.topup[topupIndex].isAmountOtherSet = false
      this.form.topup[topupIndex].amountOther = null
    },
    isAmountOtherSet (topupIndex) {
      return this.form.topup[topupIndex].isAmountOtherSet
    },
    isAmountMinMessage (topupIndex) {
      let minAmountIndex = this.showAmountMinMessage.indexOf(topupIndex)
      return minAmountIndex !== -1
    },
    isAmountMaxMessage (topupIndex) {
      let maxAmountIndex = this.showAmountMaxMessage.indexOf(topupIndex)
      return maxAmountIndex !== -1
    },
    hideAmountMessages (topupIndex) {
      let minAmountIndex = this.showAmountMinMessage.indexOf(topupIndex)
      if (minAmountIndex !== -1) {
        this.showAmountMinMessage.splice(minAmountIndex, 1)
      }

      let maxAmountIndex = this.showAmountMaxMessage.indexOf(topupIndex)
      if (maxAmountIndex !== -1) {
        this.showAmountMaxMessage.splice(maxAmountIndex, 1)
      }
    },
    setTopupAmount (amount, topupIndex) {
      this.form.topup[topupIndex].amount = amount
      this.form.topup[topupIndex].amountOther = null
      this.disableOtherAmount(topupIndex)
      this.hideAmountMessages(topupIndex)
    },
    formatAmount (topupIndex) {
      this.hideAmountMessages(topupIndex)
      let amount = parseInt(this.form.topup[topupIndex].amountOther, 10)

      if (isNaN(amount)) {
        this.form.topup[topupIndex].amountOther = null
        return
      }

      if (amount < this.$VUE_TOPUP_CONFIG.topupAmountMin) {
        amount = this.$VUE_TOPUP_CONFIG.topupAmountMin
        this.showAmountMinMessage.push(topupIndex)
      }

      if (amount > this.$VUE_TOPUP_CONFIG.topupAmountMax) {
        amount = this.$VUE_TOPUP_CONFIG.topupAmountMax
        this.showAmountMaxMessage.push(topupIndex)
      }

      this.form.topup[topupIndex].amount = amount

      if (this.$VUE_TOPUP_CONFIG.topupAmounts.includes(amount)) {
        this.disableOtherAmount(topupIndex)
      } else {
        this.form.topup[topupIndex].amountOther = amount
      }
    },
    isAmountRecommended (amount) {
      return amount === this.$VUE_TOPUP_CONFIG.topupAmountRecommend
    },
    isAmountSet (amount, topupIndex) {
      return parseInt(this.form.topup[topupIndex].amount, 10) === amount
    },
    isFormValid () {
      let phonesValid = this.form.topup
        .map(topup => Boolean(topup.isPhoneValid))
        .reduce((acc, status) => {
          return acc && status
        }, true)

      let phonesCheckPhoneValid = this.form.topup
        .map(topup => Boolean(topup.isCheckPhoneStatusValid))
        .reduce((acc, status) => {
          return acc && status
        }, true)

      let isEmailSetAndValid = (() => {
        if (this.form.email === null || !this.form.email.length) {
          return false
        }

        return !!this.form.isEmailValid
      })()

      let isAmountValid = this.form.topup
        .map(topup => Boolean(topup.amount))
        .reduce((acc, status) => {
          return acc && status
        }, true)

      return phonesValid && phonesCheckPhoneValid && isEmailSetAndValid && isAmountValid && this.isAgreementSet() &&
          this.isPaymentSet()
    },
    submit (e) {
      e.preventDefault()
      this.formError = false
      this.topupError = false

      if (!this.isFormValid()) {
        this.formError = true
        return
      }

      let totalAmount = 0
      let data = {
        products: [],
        email: this.form.email,
        language: 'PL'
      }

      this.form.topup.map(item => {
        let amount = parseInt(item.amount, 10)
        totalAmount = totalAmount + amount

        data.products.push({
          account: `48${ToolsClass.cleanPhoneNumber(item.phone)}`,
          amount: amount,
          operator: this.$VUE_APP_OPERATOR
        })

        /* global _paq */
        if (window._paq) {
          _paq.push([
            'addEcommerceItem',
            '1',
            `Doładowanie telefonu`,
            'Doładowania',
            amount,
            1
          ])
        }
      })
      this.SET_TOPUP_LOADING(true)
      this.sendTopup(data).then(response => {
        if (response.body.status === TOPUP_RESPONSE_SUCCESS && response.body.paymentLink) {
          if (window._paq && response.body.orderId) {
            _paq.push([
              'trackEcommerceOrder',
              response.body.orderId,
              totalAmount,
              false
            ])
          }

          window.parent.location.href = response.body.paymentLink
          return
        }

        this.SET_TOPUP_LOADING(false)
        this.topupError = true
      }, () => {
        this.SET_TOPUP_LOADING(false)
        this.topupError = true
      })
    }
  },
  mounted () {
    this.addTopup()

    if (this.$route.query.phone) {
      this.form.topup[0].phone = this.$route.query.phone
      this.checkPhone(0)
    }

    if (this.$route.query.backUrl) {
      CookieClass.setCookie(TOPUP_COOKIE_BACK_URL_NAME, this.$route.query.backUrl, 1)
    }

    if (Object.keys(this.$route.query).length) {
      this.$router.replace({})
    }

    let topupField = this.$refs.topupPhoneInput
    if (topupField) {
      topupField[0].focus()
    }

    this.form.topup.forEach((topup, index) => {
      this.setTopupAmount(this.$VUE_TOPUP_CONFIG.topupAmountDefault, index)
    })
  }
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
